/* eslint-disable no-unused-vars */
import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const CheckboxStyles = styled.label`
  vertical-align: middle;
  margin-right: 5px;
  margin-top: 5px;
  align-items: center;
  position: relative;
  cursor: pointer;
  font-size: 22px;
  line-height: 24px;
  height: 18px;
  width: 18px;
  clear: both;
  display: inline-block !important;
  width: 6% !important;
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    &:disabled {
      &:hover {
        cursor: not-allowed !important;
      }
    }
  }

  .checkbox-custom {
    position: absolute;
    top: 0px;
    left: -10px;
    height: 18px;
    width: 18px;
    background-color: transparent;
    border-radius: 5px;
    transition: all 0.3s ease-out;
    -webkit-transition: all 0.3s ease-out;
    -moz-transition: all 0.3s ease-out;
    -ms-transition: all 0.3s ease-out;
    -o-transition: all 0.3s ease-out;
    border: 2px solid ${(props) => props.theme.red_g};
  }

  input:disabled ~ .checkbox-custom {
    background: ${(props) => props.theme.light_grey};
    border: 2px solid ${(props) => props.theme.med_grey};
    &:hover {
      cursor: not-allowed !important;
    }
  }
  input:checked ~ .checkbox-custom {
    border-radius: 5px;
    -webkit-transform: rotate(0deg) scale(1);
    -ms-transform: rotate(0deg) scale(1);
    transform: rotate(0deg) scale(1);
    opacity: 1;
    border: 2px solid ${(props) => props.theme.green_g};
    &:disabled {
      border: 2px solid ${(props) => props.theme.red_g};
      &:hover {
        cursor: not-allowed !important;
      }
    }
  }

  .checkbox-custom::after {
    position: absolute;
    content: "";
    left: 12px;
    top: 12px;
    height: 0px;
    width: 0px;
    border-radius: 5px;
    border: solid #009bff;
    border-width: 0 3px 3px 0;
    -webkit-transform: rotate(0deg) scale(0);
    -ms-transform: rotate(0deg) scale(0);
    transform: rotate(0deg) scale(0);
    opacity: 1;
    transition: all 0.3s ease-out;
    -webkit-transition: all 0.3s ease-out;
    -moz-transition: all 0.3s ease-out;
    -ms-transition: all 0.3s ease-out;
    -o-transition: all 0.3s ease-out;
  }

  input:checked ~ .checkbox-custom::after {
    -webkit-transform: rotate(45deg) scale(1);
    -ms-transform: rotate(45deg) scale(1);
    transform: rotate(45deg) scale(1);
    opacity: 1;
    left: 4px;
    top: 0;
    width: 6px;
    height: 11px;
    border: solid ${(props) => props.theme.green_g};
    border-width: 0 2px 2px 0;
    background-color: transparent;
    border-radius: 0;
  }

  /* For Ripple Effect */
  .checkbox-custom::before {
    position: absolute;
    content: "";
    left: 10px;
    top: 10px;
    width: 0px;
    height: 0px;
    border-radius: 5px;
    border: 2px solid ${(props) => props.theme.green_g};
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
    transform: scale(0);
  }

  input:checked ~ .checkbox-custom::before {
    left: -3px;
    top: -3px;
    width: 24px;
    height: 24px;
    border-radius: 5px;
    -webkit-transform: scale(3);
    -ms-transform: scale(3);
    transform: scale(3);
    opacity: 0;
    z-index: 999;
    transition: all 0.3s ease-out;
    -webkit-transition: all 0.3s ease-out;
    -moz-transition: all 0.3s ease-out;
    -ms-transition: all 0.3s ease-out;
    -o-transition: all 0.3s ease-out;
  }

  label {
    // display: inline;
    font-size: 14px;
    font-family: "Open Sans";
    font-weight: 400;
    margin-bottom: 0;
    margin-left: 30px;
    width: 40px !important;
  }
`;

const Checkbox = ({ onClickCheck, label, value, checked, disabled }) => (
  <CheckboxStyles>
    <input
      onClick={onClickCheck}
      id={label}
      name="checkbox"
      type="checkbox"
      value={value}
      checked={checked}
      disabled={disabled}
    />
    <span className="checkbox-custom" />
  </CheckboxStyles>
);
export default Checkbox;

Checkbox.propTypes = {
  onClickCheck: PropTypes.func,
  label: PropTypes.string,
  value: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool
};
